import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FaBars, FaTimes } from "react-icons/fa";

export default function Navbar() {
  const [menuAberto, setMenuAberto] = useState(false);

  return (
    <nav className="fixed top-0 left-0 w-full bg-gradient-to-r from-yellow-500 to-yellow-600 shadow-lg p-4 flex justify-between items-center z-50">
      
      {/* Logo estilizado */}
      <Link to="/" className="text-3xl font-extrabold text-white tracking-wide flex items-center gap-2">
        <span className="text-4xl">🏢</span>
        <span className="bg-clip-text text-transparent bg-gradient-to-r from-white to-gray-200">
          Marineide Imóveis
        </span>
      </Link>

      {/* Menu Desktop */}
      <div className="hidden md:flex gap-8">
        <Link to="/" className="text-white font-medium hover:text-gray-200 transition">
          Imóveis
        </Link>
        <Link to="/catalogo" className="text-white font-medium hover:text-gray-200 transition">
          Catálogo
        </Link>
        <Link to="/contato" className="text-white font-medium hover:text-gray-200 transition">
          Contato
        </Link>
      </div>

      {/* Botão de Menu Hambúrguer no Mobile */}
      <button
        className="md:hidden text-3xl text-white focus:outline-none"
        onClick={() => setMenuAberto(!menuAberto)}
      >
        {menuAberto ? <FaTimes /> : <FaBars />}
      </button>

      {/* Menu Mobile */}
      {menuAberto && (
        <motion.div
          className="absolute top-16 left-0 w-full bg-yellow-500 shadow-md flex flex-col items-center py-6 space-y-4 md:hidden"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          <Link to="/" className="text-white text-lg hover:text-gray-200 transition" onClick={() => setMenuAberto(false)}>
            Imóveis
          </Link>
          <Link to="/catalogo" className="text-white text-lg hover:text-gray-200 transition" onClick={() => setMenuAberto(false)}>
            Catálogo
          </Link>
          <Link to="/contato" className="text-white text-lg hover:text-gray-200 transition" onClick={() => setMenuAberto(false)}>
            Contato
          </Link>
        </motion.div>
      )}
    </nav>
  );
}
